// @flow

<template>
  <tr>
    <td class="order_item_type">{{ $t(`generic.orderItemType.${orderItem.orderItemType}`) }}</td>
    <td class="engraved_id">{{ orderItem.engravedIdString | engravedId }}</td>
    <td class="tariff_name">{{ orderItem.tariffName }}</td>
    <td class="date_effective">{{ orderItem.dateEffective | dateFormatOrDefault('-') }}</td>
    <td class="order_status">{{ $t(`generic.status.${orderItem.orderStatus}`) }}</td>
  </tr>
</template>

<script>
import engravedId from '../../filters/engraved-id'
import {dateFormatOrDefault} from '../../filters/date-format'

export default {
  name: 'OrderItemListItem',
  filters: {
    dateFormatOrDefault,
    engravedId
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/orderItems/OrderItemListItem.vue